import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import {
  RenewalPlanView,
  RenewalSourcePassePartoutView,
  SourceToTargetPassePartoutMap
} from '../../services/order-renewal-extensions.service';

@Component({
    selector: 'app-renewal-mapping-dialog',
    templateUrl: './renewal-mapping-dialog.component.html',
    styleUrls: ['./renewal-mapping-dialog.component.scss'],
    standalone: false
})
export class RenewalMappingDialogComponent implements OnInit {

  public plan: RenewalPlanView;
  public form!: FormGroup;
  public hasTargets: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public passedData: { plan: RenewalPlanView },
    public dialogRef: MatDialogRef<RenewalMappingDialogComponent>
  ) {
    this.plan = passedData.plan;
    this.hasTargets = (this.plan?.EligibleTargets?.length ?? 0) > 0;
  }

  ngOnInit() {
    const controls: { [key: string]: FormControl<number | null> } = {};
    for (const source of this.plan.SourcePassePartouts) {
      controls[this.controlKey(source.Id)] = new FormControl<number | null>(null);
    }
    this.form = new FormGroup(controls);
  }

  controlKey(sourcePpId: number): string {
    return 'pp_' + sourcePpId;
  }

  trackBySourceId(_index: number, item: RenewalSourcePassePartoutView): number {
    return item.Id;
  }

  confirm() {
    const raw = this.form.getRawValue();
    const map: SourceToTargetPassePartoutMap = {};
    for (const source of this.plan.SourcePassePartouts) {
      const value = raw[this.controlKey(source.Id)];
      map[String(source.Id)] = value ?? null;
    }
    this.dialogRef.close(map);
  }

  cancel() {
    this.dialogRef.close(undefined);
  }
}
